export default {
  title: "Mis POAPs",
  empty: {
    titleLead: "Tu cartera está vacía.",
    titleEmphasis: "De momento.",
    description: "Los POAPs que mintees aparecerán aquí, verificables on-chain. Empieza por la colección.",
    button: "Explorar POAPs",
  },
}
